import cx from "classnames";
import {
  ActionBlock,
  Header,
  TranslatedString,
  LogoutModal,
  FlexBox,
  Button,
  Card,
  Image,
} from "components";
import {
  dashboardSideMenuList,
  globalConstant,
  sideMenuList,
  SIDE_MENU_CUSTOM_ACTIONS,
} from "../../../constants";
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { SideMenuProps } from "./types";
import { ChangeHistory, nameFunctions } from "utils";
import Logo from "assets/logo.svg";
import ShortLogo from "assets/short-logo.png";
import RightArrowImg from "assets/icons/down-arrow.png";
import ProfileIcon from "assets/icons/profile.svg";
import {
  setGeneralDetails,
  useAllApplicationsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
} from "Slices";
import { ROUTE_PATH } from "Routes";
const SideMenu: React.FC<SideMenuProps> = ({ isOpened, menuCloseCallback }) => {
  const generalDetails = useGeneralDetails();
  const userDetails = useGetUserDetailsApiDetails();

  const [isDropDownOpened, setIsDropDownOpened] = useState(false);
  const [logoutModalVisibility, setLogoutModalVisibility] = useState(false);
  const allApplications = useAllApplicationsApiDetails();

  useEffect(() => {
    if (!generalDetails.activeSideMenuOption) {
      setGeneralDetails({
        activeSideMenuOption: sideMenuList[0]["text"],
      });
    }
  }, []);

  const renderActionBlock = (item: any, index: number) => {
    return (
      <FlexBox
        key={`acton-block-${index}`}
        onClick={() => {
          setGeneralDetails({
            activeSideMenuOption: item["text"],
            isDashboardSideMenuOpened: false,
          });
          if (item["onClick"].includes("/"))
            ChangeHistory("push", item["onClick"]);
          else
            switch (item["onClick"]) {
              case SIDE_MENU_CUSTOM_ACTIONS.REFER:
                break;

              case SIDE_MENU_CUSTOM_ACTIONS.EMAIL:
                break;

              case SIDE_MENU_CUSTOM_ACTIONS.RATE:
                break;

              case SIDE_MENU_CUSTOM_ACTIONS.LOGOUT:
                setLogoutModalVisibility(true);
                break;
                break;

              default:
                break;
            }
        }}
        className={cx(
          generalDetails.activeSideMenuOption === item["text"] &&
            "clr-theme font-medium active-side-menu-option",
          "pd-15 transition clicking-animation curs-point options"
        )}
      >
        <Image
          src={
            item[
              generalDetails.activeSideMenuOption === item["text"]
                ? "activeImg"
                : "img"
            ]
          }
        />
        <p className="mr-l-10 fs-16"> {item["text"]}</p>
      </FlexBox>
    );
  };

  const returnActionBlock = (item: any, index: number) => {
    return item["text"] === "Getting Started"
      ? !(allApplications?.data?.length > 0) && renderActionBlock(item, index)
      : renderActionBlock(item, index);
  };

  const logout = () => {
    localStorage.removeItem("token");
    ChangeHistory("back", ROUTE_PATH.DASHBOARD.SIGNUP_LOGIN);
  };

  const closeSideMenu = () => {
    setGeneralDetails({
      isDashboardSideMenuOpened: false,
    });
  };

  return (
    <nav
      className={cx(
        generalDetails?.isDashboardSideMenuOpened &&
          "dashboard-side-menu-opened",
        "dashboard-side-menu border-right"
      )}
    >
      <FlexBox flexColumn justifyBetween className="h-100">
        <div>
          <div className="pos-rel">
            <FlexBox
              justifyBetween
              alignCenter
              className="profile-section pd-20 z-1 bg-white pos-rel curs-point"
              onClick={() => {
                setIsDropDownOpened(!isDropDownOpened);
              }}
            >
              <FlexBox>
                <Image src={ProfileIcon} className="w-15" />
                <div className="mr-l-10">
                  <p className="fs-14 font-heavy">
                    Hi {userDetails?.data?.name ?? "user"}
                  </p>
                  <p className="fs-12">
                    {generalDetails?.selectedOrganisation?.companyName}
                  </p>
                </div>
              </FlexBox>
              <Image
                src={RightArrowImg}
                className={cx(
                  isDropDownOpened && "rotate180",
                  "w-10 dashboard-side-menu-dropdown-right-arrow transition"
                )}
              />
            </FlexBox>
            <div
              className={cx(
                isDropDownOpened && "dashboard-side-menu-dropdown-opened",
                "dashboard-side-menu-dropdown fs-14"
              )}
            >
              <p
                className="curs-point clicking-animation pd-10 pd-t-0"
                onClick={() => {
                  closeSideMenu();
                  ChangeHistory("push", ROUTE_PATH.DASHBOARD.PROFILE);
                }}
              >
                Profile
              </p>
              <p
                className="curs-point clicking-animation pd-10"
                onClick={() => {
                  closeSideMenu();
                  ChangeHistory("push", ROUTE_PATH.DASHBOARD.ORGANIZATION);
                }}
              >
                Organisation
              </p>
              <p
                className="curs-point clicking-animation pd-10 pd-b-0"
                onClick={() => {
                  logout();
                }}
              >
                Logout
              </p>
            </div>
          </div>
          <div>
            <div className="dashboard-side-menu-options">
              {dashboardSideMenuList?.map(returnActionBlock)}
            </div>
            {window.screen.width <= 968 && (
              <div className="mr-t-20">
                <FlexBox justifyBetween flexColumn>
                  <p
                    className="font-medium fs-16 curs-point mr-h-20"
                    onClick={() => {
                      ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
                    }}
                  >
                    OTPless.com
                  </p>
                  <p
                    className="font-medium fs-16 curs-point mr-20"
                    onClick={() => {
                      ChangeHistory("push", ROUTE_PATH.DOCS.HOME);
                    }}
                  >
                    Docs
                  </p>
                </FlexBox>
              </div>
            )}
          </div>
        </div>
        <div className="help-center pos-rel br-9 mr-20">
          <Card className="short-logo pd-10 dsp-fl justify-center align-center">
            <Image src={ShortLogo} className="w-90" />
          </Card>
          <FlexBox
            className="pos-rel text-center overflow-hdn pd-20 content br-9"
            alignCenter
            flexColumn
          >
            <div className="left-top design-circle" />
            <div className="right-bottom design-circle" />
            <p className="fs-16">Help Center</p>
            <p className="fs-14 clr-disabled mr-v-20">
              Having trouble with OTPless? Please reach out to us on
            </p>
            <Button
              text={"help@otpless.com"}
              onClick={() => {
                ChangeHistory("blank", "mailto: help@otpless.com");
              }}
              className="no-border w-100"
            />
          </FlexBox>
        </div>
        <LogoutModal
          visible={logoutModalVisibility}
          onClose={() => {
            setLogoutModalVisibility(false);
          }}
          logoutAction={() => {
            // do logout
          }}
        />
      </FlexBox>
    </nav>
  );
};
export default SideMenu;
